module.exports = __webpack_public_path__ + "static/img/p5.25faa2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p5.jpg
// module id = /z4c
// module chunks = 1